/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MarkerTypeFromJSON, MarkerTypeToJSON, } from './MarkerType';
import { UserIncidentFootageFromJSON, UserIncidentFootageToJSON, } from './UserIncidentFootage';
/**
 * Check if a given object implements the UserIncidentFootageMarker interface.
 */
export function instanceOfUserIncidentFootageMarker(value) {
    let isInstance = true;
    return isInstance;
}
export function UserIncidentFootageMarkerFromJSON(json) {
    return UserIncidentFootageMarkerFromJSONTyped(json, false);
}
export function UserIncidentFootageMarkerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'rowVersion': !exists(json, 'rowVersion') ? undefined : json['rowVersion'],
        'markerType': !exists(json, 'markerType') ? undefined : MarkerTypeFromJSON(json['markerType']),
        'offsetMs': !exists(json, 'offsetMs') ? undefined : json['offsetMs'],
        'userIncidentFootageId': !exists(json, 'userIncidentFootageId') ? undefined : json['userIncidentFootageId'],
        'userIncidentFootage': !exists(json, 'userIncidentFootage') ? undefined : UserIncidentFootageFromJSON(json['userIncidentFootage']),
    };
}
export function UserIncidentFootageMarkerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'rowVersion': value.rowVersion,
        'markerType': MarkerTypeToJSON(value.markerType),
        'offsetMs': value.offsetMs,
        'userIncidentFootageId': value.userIncidentFootageId,
        'userIncidentFootage': UserIncidentFootageToJSON(value.userIncidentFootage),
    };
}
